import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../services/Auth.service";
import { useTranslation } from "react-i18next";
import HomeFarmsPanel from '../components/HomeComponents/HomeFarmsPanel';

export default function Home() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div>
                    <div>
                        <HomeFarmsPanel />
                    </div>
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
